import { siteConfig } from '../variables/config'
import HttpService from './Http.services';
import i18n from 'i18next';
import Cookies from 'universal-cookie';
import store from '../stores/storeConfig';

const cookies = new Cookies();

function translate(key, params) {
    return (
        i18n.t(key, params)
    )
}


function checkPermission(requiredPermission, showLog, applet) {
    // console.log(requiredPermission)
    // return true
    let userPermissions = store.getState().user?.info?.permissions
    if (!userPermissions) {
        userPermissions = []
    }

    let appletId = applet?.key ?? applet?._id ?? applet
    // console.log("userPermissions", requiredPermission, userPermissions)

    // return true
    for (let i = 0; i < userPermissions.length; i++) {

        // console.log(appletId, userPermissions[i].applet)
        if (!applet || appletId == userPermissions[i].applet) {
            const userPermission = userPermissions[i].permissions;
            if (showLog) {
                // console.log(requiredPermission)
                // console.log(userPermission)
            }
            // console.log(userPermission)
            if (Array.isArray(requiredPermission)) {
                for (let j = 0; j < requiredPermission.length; j++) {
                    const myRequiredPermission = requiredPermission[j];
                    // console.log(myRequiredPermission)
                    // console.log(userPermission)
                    let res = getPermissionObject(userPermission, myRequiredPermission)
                    if (res?.allowed) {
                        return true
                    }

                }
            } else {
                let res = getPermissionObject(userPermission, requiredPermission)
                if (res?.allowed) {
                    // console.log("ALLOWED")
                    return true
                }
            }
        }
    }

    return false



}


function getPermissionObject(data, key, parentKey, reverse, fullData) {

    if (!parentKey) {
        parentKey = ''
    }
    // console.log(data, key)

    if (data && key) {

        // if (reverse) {
        //     console.log(data,parentKey, key, reverse)
        // }

        if (data == '*') {
            if (reverse) {
                return { allowed: false, parentLevel: true, parentKey: parentKey }
            } else {
                return { allowed: true, parentLevel: true, parentKey: parentKey }
            }
        } else {
            if (key.includes('.')) {
                let pList = key.split('.');
                let newKey = [...pList]
                newKey.splice(0, 1).join('.')
                newKey = newKey.join('.')
                // console.log(data, pList[0],data[pList[0]])
                if (data[pList[0]] == '*') {
                    if (reverse) {
                        return { allowed: false, parentLevel: true, parentKey: parentKey, value: '*' }
                    } else {
                        parentKey = parentKey + (parentKey != "" ? '.' : '') + pList[0]
                        return { allowed: true, parentLevel: true, parentKey: parentKey, value: '*' }
                    }

                } else {
                    parentKey = parentKey + (parentKey != "" ? '.' : '') + pList[0]
                    return getPermissionObject(data[pList[0]], newKey, parentKey, reverse, fullData ?? data)
                }
            } else {


                let value = data[key]
                if (value && typeof value == 'object' && !Array.isArray(value)) {
                    if (Object.keys(value).length == 0) {
                        value = null
                    }
                }
                // console.log("VALUE",value)
                return { allowed: ((value == '*' || value)) ? true : false, value: value, parentKey: parentKey, key: key }
            }
        }
    } else {
        return { allowed: false }
    }
}




function checkTextTranslation(text) {
    if (text && typeof text == 'string') {
        if (text.includes("{{lang}}")) {
            let newText = text
            newText = newText.replace('{{lang}}', '')
            newText = i18n.t(newText)
            return newText

        } else {
            return text
        }
    }
}


function checkTranslation(text) {
    if (text) {
        if (String(text).includes("{{lang}}")) {
            let newText = String(text)
            newText = newText.replace('{{lang}}', '')
            newText = i18n.t(newText)
            return newText

        } else {
            return text
        }
    }
}



function changeBodyDirection(language) {

    if (language === 'fa') {
        document.body.classList.remove('ltr')
        document.body.classList.add('rtl')
    } else {
        document.body.classList.remove('rtl')
        document.body.classList.add('ltr')
    }
}


function currentLng() {
    return i18n.language
}


function changeUrlWithLng(lng) {
    let pathname = window.location.pathname.split('/')
    for (let index = pathname.length - 1; index >= 0; index--) {
        if (pathname[index] === "") {
            pathname.splice(index, 1)
        }
    }


    if (lng === siteConfig.defaultLng && siteConfig.dontShowUrlForDefaultLng) {
        if (siteConfig.languages.indexOf(pathname[0]) !== -1) {
            // console.log(pathname.splice(0, 1).join('/'))
            pathname.splice(0, 1)
            pathname = pathname.join('/')
            window.location = '/' + pathname

        }
    } else {

        if (lng !== pathname[0]) {

            if (!pathname[0] || siteConfig.languages.indexOf(pathname[0]) !== -1) {
                pathname[0] = lng
            } else {
                pathname.splice(0, 0, lng)
            }
            window.location = "/" + pathname.join('/')
        }
    }
}


function defaultPathMaker() {
    return siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language
}

function pathMaker(path) {
    return defaultPathMaker() + path
}

function imageAddress(image, type, prefered) {
    // console.log(image)
    let imageInfo = {
        profile: { address: 'uploads/', defaultImg: '/images/male.png' },
        product: { address: 'uploads/', defaultImg: '/images/default.jpg' },
        resource: { address: 'uploads/', defaultImg: '/images/noimageavailable.png' },
        estate: { address: 'uploads/', defaultImg: '/images/def.jpg' },

    }

    let prefixAddress = 'uploads/'
    let defaultImg = ''
    if (imageInfo[type]) {
        prefixAddress = imageInfo[type].address
    }
    if (imageInfo[type] && imageInfo[type].defaultImg) {
        defaultImg = imageInfo[type].defaultImg
    } else {
        defaultImg = '/images/noimageavailable.png'
    }



    if (image && image != '') {

        let imageName = ''
        let myImage = Array.isArray(image) ? image[0] : image

        if (prefered && myImage.sizes && myImage.sizes[prefered]) {
            // console.log("HERE")
            imageName = myImage.sizes[prefered].address

        } else {
            if (typeof myImage === "object" && !Array.isArray(myImage)) {
                // console.log(image.address)
                imageName = myImage.address
            } else {
                imageName = myImage
            }
        }


        let final = siteConfig.assetsDomain + prefixAddress + imageName
        // console.log(final)

        return final
    } else {
        return defaultImg
    }

}


function getToken() {
    let token = cookies.get('admintoken')
    if (typeof token === "undefined") {
        token = null
    }
    return token
}

function getUserInfo(cb) {
    // console.log("getUserInfo")
    HttpService.request("employeeGetInfo", null, (fetchResult, fetchError, status) => {
        // console.log(fetchResult)
        // console.log(fetchError)

        if (fetchError) { if (cb) { cb(null, fetchError.message, status) }; return }
        if (cb) { cb(fetchResult, null, status) }
    })
}




function getOneThing(info, cb) {
    HttpService.request("getOneThing", { id: info.id }, (fetchResult, fetchError, status) => {
        // console.log(status)
        if (fetchError) { if (cb) { cb(null, fetchError.message, status) }; return }
        if (cb) { cb(fetchResult, null, status) }
    })
}



function phoneStandardView(number) {
    let phone = number
    if (number) {
        if (number.includes('-')) {
            phone = number.substring(4, number.length)
        }
        let counter = 0
        while (number[counter] === "0") {
            counter++
        }

        phone = phone.substring(counter, number.length)
        return phone
    }
}



let numbers = { '0': '۰', '1': '۱', '2': '۲', '3': '۳', '4': '۴', '5': '۵', '6': '۶', '7': '۷', '8': '۸', '9': '۹' }

function converNumberToPersian(number) {
    if (number != null) {
        let numberArray = String(number).split('')
        numberArray.forEach((element, index) => {
            if (numbers[element]) {
                numberArray[index] = numbers[element]
            }
        });
        return numberArray.join('')

    }
}


function priceStandardView(priceRef) {
    if (priceRef && !priceRef.includes('%')) {
        // console.log(priceRef)
        let normalized = priceRef

        let priceSides = String(normalized).split('.')

        let priceArray = String(priceSides[0]).split('')
        let price = ''
        // let j = 0
        for (let i = 0; i < priceArray.length; i++) {
            let element = priceArray[priceArray.length - 1 - i];
            // j++
            price = element + price
            // console.log(price)
            if ((i + 1) % 3 === 0 && i !== priceArray.length - 1) {
                price = ',' + price
            }
            // console.log(price)

        }
        if (price == null) {
            price = 0
        }
        if (priceSides[1]) {
            price = price + '.' + priceSides[1].substr(0, 2)

        }
        return price

    } else {
        return priceRef
    }
}



function setObject(data, key, value, append, index) {
    // console.log(key)
    // console.log(value)
    // console.log(data)
    if (!data) data = {}

    // if(key)

    if (key && key.includes('.')) {

        // if(key.includes("["))
        let pList = key.split('.');
        let newKey = [...pList]

        pList = pList[0]
        newKey.splice(0, 1)
        newKey = newKey.join('.')
        let newData
        if (pList.includes('[')) {
            let conditions = /\[(.*?)\]/.exec(pList)
            if (conditions) {
                let condition = conditions[1]
                let tempKey = pList.replace(conditions[0], '')
                pList = tempKey
                if (Array.isArray(data[tempKey])) {
                    let arrayIndex = extactArrayElementWithCondition(data[tempKey], condition)
                    if (arrayIndex != null) {
                        data[pList][arrayIndex] = setObject(data[pList][arrayIndex], newKey, value, index)
                    }
                }
            }
        } else {

            // if (pList.includes('*')) {
            //     let keyValue = pList.split('*')
            //     newData = data[keyValue[1]][keyValue[0]]
            //     console.log(newData)
            // } else {
            if (typeof data == 'object') {
                newData = data[pList]
                data[pList] = setObject(newData, newKey, value, index)
            }


        }

        return data

    } else {

        if (key.includes('~')) {
            // console.log("******")
            let valueIndex = key.split('~')
            // console.log(data)
            // console.log(valueIndex)
            // console.log(data[valueIndex[0]][valueIndex[1]])
            if (data[valueIndex[0]] && data[valueIndex[0]][valueIndex[1]]) {
                data[valueIndex[0]][valueIndex[1]] = value
            } else {
                data[key] = value
            }

        } else {

            if (append) {
                // console.log("APPLED")
                // console.log(key)
                if (append == 'object') {

                    for (const [nkey, nvalue] of Object.entries(value)) {
                        // console.log(nkey)
                        // console.log(nvalue)
                        if (!data[key]) {
                            data[key] = {}
                        }
                        data[key][nkey] = nvalue
                    }

                } else {

                    data[key] = data[key] ? data[key] : []
                    if (Array.isArray(value)) {
                        data[key] = [...data[key], ...value]
                    } else {


                        data[key] = [...data[key], value]
                    }
                }
            } else {
                if (index != null) {

                    data[index][key] = value

                } else {
                    if (!data) {
                        data = {}
                    }
                    // console.log(data)
                    if (typeof data == 'object') {
                        data[key] = value
                    }
                }
                // console.log(key)
                // console.log(value)

            }
        }
        return data

    }

}


function extactArrayElementWithCondition(data, rawCondition) {
    let result
    let regex = /\*(.*?)\*/

    let condition = rawCondition.match(regex)[1]
    if (condition) {
        let sides = rawCondition.split(rawCondition.match(regex)[0])
        data.forEach((element, index) => {
            if (element[sides[0]] == sides[1]) {
                result = index
            }
        });
    }
    return result

}


// function setObject(data, key, value, append, index) {

//     if (!data) data = {}
//     if (key && key.includes('.')) {

//         // if(key.includes("["))
//         let pList = key.split('.');
//         let newKey = [...pList]
//         newKey.splice(0, 1)
//         newKey = newKey.join('.')
//         data[pList[0]] = setObject(data[pList[0]], newKey, value)
//         return data

//     } else {
//         if (append) {
//             data[key] = data[key] ? data[key] : []
//             if (Array.isArray(value)) {
//                 data[key] = [...data[key], ...value]
//             } else {
//                 data[key] = [...data[key], value]
//             }
//         } else {
//             if (index != null) {
//                 data[index][key] = value
//             } else {
//                 data[key] = value
//             }
//         }
//         return data
//     }

// }

function getObject(data, key, splitLevel, level, index) {


    if (data && key) {

        if (key.includes('.') && (splitLevel == null || level == null || splitLevel > (level ? level : 0))) {
            let pList = key.split('.');
            let newKey = [...pList]
            newKey.splice(0, 1).join('.')
            newKey = newKey.join('.')
            return getObject(data[pList[0]], newKey, splitLevel, level ? level + 1 : 1, index)

        } else {

            return data[key]
        }
    } else {
        return null
    }
}


function capitalLetter(text) {
    if (text) {
        let words = text.split(' ')
        let newWords = []
        words.forEach((word, index) => {
            let newWord = word
            newWord = newWord.substr(0, 1).toUpperCase() + newWord.substr(1)
            newWords.push(newWord)
        });
        return newWords.join(' ')
    }
}

function chooseWallpaper(data) {
    // console.log(data)
    if ((data && data[0] && data[0].values && data[0].values.image)) {
        let image = Array.isArray(data[0].values.image) ? data[0].values.image[0] : data[0].values.image
        return siteConfig.assetsDomain + 'images/' + image.address
    }
    // return "/images/cover2.jpeg"
    // return "/images/cover.jpg"

}



function fetchWallpaper(page, options, cb) {
    console.log(page)
    HttpService.request('getValuesWithData', { applet: 'wallpapers', filter: { 'values.page': page } }, (fetchResult, fetchError) => {
        console.log(fetchResult)
        if (fetchError) { cb(null, fetchError) }
        if (fetchResult && fetchResult.info) {
            console.log(fetchResult)
            let wallpaper = Array.isArray(fetchResult.info) ? fetchResult.info[0] : fetchResult.info

            wallpaper = imageAddress(wallpaper.values.image)
            cb(wallpaper, fetchError)
        }
    })
}



function togglePin(data, options, cb) {

    HttpService.request('togglePin', data, (fetchResult, fetchError) => {
        console.log(fetchResult)
        if (fetchError) { cb(null, fetchError) }

        cb(fetchResult.pinned)

    })
}


function detectBrowser() {
    // Opera 8.0+
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        return 'Opera'
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        return 'Chrome'
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
        return 'Safari'
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        return 'Firefox'
    } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
    {
        return 'IE'
    } else {
        return ''
    }

}






function paramsToValue(data, content, fields, preLabel, returnRaw) {

    // console.log("paramsToValue")
    // console.log(content)

    if (content && typeof content == 'string') {

        let output = content

        let reg = new RegExp('\{\{(.*?)\}\}', 'g')

        let matches = content.match(reg)

        if (matches) {
            for (let index = 0; index < matches.length; index++) {
                const match = matches[index];

                let key = match.replace(/{/g, '').replace(/}/g, '')


                // console.log(fields)
                // console.log(key)

                if (fields) {
                    for (let j = 0; j < fields.length; j++) {
                        const header = fields[j]

                        let label = header.information?.label
                        if (preLabel) {
                            label = preLabel + ' - ' + label
                        }

                        label = label.replace("{{lang}}", '')

                        // console.log(label)

                        if (key == header.information?.label || key == label || key == header.key) {

                            if (data) {
                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }

                                if (typeof value == 'string') {
                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, value)
                                } else {
                                    output = value
                                }
                            } else {
                                output = header.key
                            }

                        }


                    }
                }
            }
        } else {
            if (data) {
                output = getObject(data, content)
            } else {
                output = content
            }
        }

        return output

    }

}





export { paramsToValue, translate, checkPermission, detectBrowser, getPermissionObject, togglePin, getOneThing, changeBodyDirection, changeUrlWithLng, currentLng, checkTextTranslation, checkTranslation, pathMaker, imageAddress, getToken, getUserInfo, phoneStandardView, getObject, setObject, capitalLetter, chooseWallpaper, priceStandardView, converNumberToPersian, fetchWallpaper }